<template>
    <f7-page
        name="Username"
        class="onboardingBg"
    >
        <f7-navbar
            large
            no-hairline
            large-transparent
            inner-class="onboardingBg"
            title-large="Community"
        >
            <f7-nav-left>
                <f7-link
                    icon="ion-ios-arrow-left"
                    back
                />
            </f7-nav-left>
            <f7-nav-title>Community</f7-nav-title>
            <!-- <f7-nav-right>
                <f7-link @click="save()">Save</f7-link>
            </f7-nav-right> -->
        </f7-navbar>
        <f7-block
            v-if="user.email && !user.emailVerified"
            style="background: #FC6E65; color: white; padding: 10px; margin: 10px 0 0 0"
        >Oops! It looks like you forgot to verify your email. Didn't receive anything? Click
            <a
                href="#"
                style="text-decoration: underline; color: white;"
                @click="resendEmail"
            >HERE</a>
            to resend.</f7-block>

        <f7-block-title style="margin-bottom: 0px;">Public Username</f7-block-title>
        <f7-block style="text-align: left; margin-bottom: 0px;">
            Hello! In order to join this convo you have to choose your username. </f7-block>
        <f7-list
            inset
            class="bordered"
            style="margin-top: 10px"
        >
            <f7-list-input
                :value="newUsername"
                label="Username"
                type="text"
                placeholder="Your name"
                @input="newUsername=$event.target.value.replace(/[\W_]+/g, '_'); checkUserName()"
            >
                <f7-link
                    v-if="errorMessage"
                    slot="label"
                    style="float: right; color: red"
                >{{ errorMessage }}</f7-link>
                <f7-link
                    v-else-if="newUsername"
                    slot="label"
                    style="float: right; color: green"
                >VALID</f7-link>
            </f7-list-input>
        </f7-list>
        <f7-block-title style="margin-bottom: 0px; line-height: 22px">Community guidelines</f7-block-title>
        <f7-block style="text-align: left;">
            <ul>
                <li>Always be helpful and respectful</li>
                <li>Don’t threaten or encourage harm</li>
                <li>No ads, spam, porn or disinformation</li>
                <li>No illegal activity of any kind</li>
            </ul>
            Spoiler alert! By clicking accept you agree to our community guidelines. They’re pretty straightforward but you should still take a look (find them in settings > Terms & Conditions).
            <br><br>
            <f7-button
                color="red"
                fill
                round
                @click="save();"
            >Accept</f7-button>
        </f7-block>

    </f7-page>
</template>

<script>
import firebase from 'firebase/app';
import _ from 'lodash';
import 'firebase/auth';

export default {
    store: ['api', 'text', 'user', 'darkTheme'],
    data () {
        return {
            newUsername: '',
            errorMessage: '',
            returnUrl: '',
            view: 'main',
        };
    },
    computed: {},
    created: function () {
        this.newUsername = (' ' + this.user.username).slice(1); // deep copy
        if (this.$f7route.query.returnUrl) {
            this.returnUrl = this.$f7route.query.returnUrl;
        }
        if (this.$f7route.query.view) {
            this.view = this.$f7route.query.view;
        }
    },
    mounted: function () {
    },
    methods: {
        checkUserName: _.debounce(function () {
            this.newUsername = this.newUsername.replace(/[\W_]+/g, "_");
            console.log('B', this.newUsername)
            if (this.newUsername.length < 3) return this.errorMessage = 'Too short';
            if (this.newUsername === this.user.username) return this.errorMessage = ''; // current
            this.$http.get(`${this.api}/username?username=${this.newUsername}`).then(
                response => {
                    if (response.body) {
                        this.errorMessage = '';
                    } else {
                        this.errorMessage = 'Taken';
                    }
                },
                response => {
                    if (response.body.message) {
                        this.errorMessage = response.body.message;
                    } else {
                        this.errorMessage = 'Invalid';
                    }
                });
        }, 200),
        save: function () {
            if (this.errorMessage) return;
            this.user.username = this.newUsername;
            this.$events.fire('user-save', () => {
                if (this.returnUrl) {
                    f7.views[this.view].router.navigate(this.returnUrl);
                } else {
                    f7.views[this.view].router.back();
                }
            });
        },
        resendEmail: function () {
            var user = firebase.auth().currentUser;
            user.sendEmailVerification()
                .then(function () {
                    f7.dialog.alert('Email sent.');
                })
                .catch(function (error) {
                    console.log('email v ', error);
                });
        },
    }
};
</script>

<style lang="less" scoped>
@import '../../css/colors.less';
.center {
    text-align: center;
}
.version {
    text-transform: uppercase;
    font-family: AndesMedium;
    letter-spacing: 1px;
    color: #ccc;
    line-height: 20px;
    text-transform: uppercase;
}
</style>
